import {call, put, select} from "redux-saga/effects";
import api from "../../services/api";
import {Creators as BorderosActions} from "../ducks/borderos";
import {Creators as ModalActions} from "../ducks/modal";
import {Creators as AlertActions} from "../ducks/alert";
import {Creators as ErrorActions} from "../ducks/error";
import {Creators as SuccessActions} from "../ducks/success";
import {Creators as LoadingActions} from "../ducks/loading";
import {Creators as PageActions} from "../ducks/pages";
import {Creators as ModalPrint} from "../ducks/modalPrint";
import {formatReal, formatSize} from "../../helpers";
import moment from "moment";
import {Creators as ModalDocsActions} from "../ducks/modalDocs";

export function* getListBorderos() {
  try {
    yield put(LoadingActions.setLoading());
    const {page, rowsPerPage, filter} = yield select(state => state.borderos);
    const {data} = yield call(
      api.post,
      `/borderos/filter?page=${page + 1}&per_page=${rowsPerPage}`,
      filter
    );
    const countPropostasPendentes = sales => ({
      total: sales.reduce((total, current) => {
        return current.docs ? total : total + 1;
      }, 0)
    });
    const {data: borderos, total} = data;
    let borderosPayload = [];
    borderosPayload = borderos.map(bordero => ({
      id: bordero.id,
      name: bordero.code,
      stores: bordero.stores,
      users: bordero.users,
      total_sales: bordero.sales ? bordero.sales.length : 0,
      total_sales_ok: bordero.sales
        ?
        countPropostasPendentes(bordero.sales).total
          ? `<span class="error-text">${countPropostasPendentes(bordero.sales).total}</span>`
          : ''
        : '',
      total_financed: bordero.sales
        ? formatReal(
          bordero.sales.reduce((total, current) => {
            return total + current.value_financed;
          }, 0)
        )
        : 0,
      total_released: bordero.sales
        ? formatReal(
          bordero.sales.reduce((total, current) => {
            return total + current.value_released;
          }, 0)
        )
        : 0,
      created_at: bordero.created_at
        ? moment(bordero.created_at).format("DD/MM/YYYY")
        : "",
      send_at: bordero.send_at
        ? moment(bordero.send_at).format("DD/MM/YYYY")
        : "",
      received_at: bordero.received_at
        ? moment(bordero.received_at).format("DD/MM/YYYY")
        : ""
    }));
    const name = "Borderôs";
    const path = "borderos";
    yield put(PageActions.setPage(name, path));
    yield put(BorderosActions.getListBorderosSuccess(borderosPayload, total));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getBorderos({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data} = yield call(api.get, `/borderos/${payload.id}`);
    data.sales = data.sales.map(proposta => ({
      id: proposta.id,
      borderoId: payload.id,
      date: proposta.date ? moment(proposta.date).format("DD/MM/YYYY") : "",
      contract_number: proposta.contract_number,
      customer: proposta.customer.name,
      cpf_cnpj: proposta.customer.cpf_cnpj,
      bank: proposta.bank.name,
      product: proposta.product.name,
      operation: proposta.operation.name,
      deadline: proposta.deadline,
      value_financed: proposta.value_financed
        ? formatReal(proposta.value_financed)
        : 0,
      value_released: proposta.value_released
        ? formatReal(proposta.value_released)
        : 0,
      docs:
        proposta.notes && !proposta.docs
          ? `<span class="s-docs docs-not-ok"><span class='tag-child'><span class='tag-row'>Observações: ${
            proposta.notes
          }</span></span>
              ${
            proposta.files.length <= 0 &&
            proposta.customer.files.length <= 0
              ? '<i class="fa fa-folder-o fa-lg" />'
              : '<i class="fa fa-folder fa-lg has-files" />'
          }
              </span>`
          : proposta.docs
          ? `<span class="s-docs docs-ok"><span class='tag-child'><span class='tag-row'>Documentação Ok</span></span>${
            proposta.files.length <= 0 && proposta.customer.files.length <= 0
              ? '<i class="fa fa-folder-o fa-lg" />'
              : '<i class="fa fa-folder fa-lg has-files" />'
          }</span>`
          : `<span class="s-docs docs-not-ok">${
            proposta.files.length <= 0 && proposta.customer.files.length <= 0
              ? '<i class="fa fa-folder-o fa-lg" />'
              : '<i class="fa fa-folder fa-lg has-files" />'
          }</span>`,
      docs_ok: proposta.docs ? proposta.docs : 0
    }));
    yield put(BorderosActions.getBorderosSuccess(data));
    const {action} = yield select(state => state.borderosStores);
    if (action === "PRINT") {
      yield put(BorderosActions.printBordero(data.id));
    } else if (action === "SEND") {
      yield put(ModalActions.open());
    } else if (action === "CHECK") {
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O bordero "${
        data.code ? data.code : data.id
        }" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editBorderos({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/borderos/${payload.id}`, payload);
    yield put(BorderosActions.getListBorderos());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addBorderos({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/borderos`, payload);
    yield put(BorderosActions.searchBorderos({}));
    yield put(BorderosActions.getListBorderos());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteBorderos() {
  try {
    yield put(LoadingActions.setLoading());
    const {id} = yield select(state => state.borderos.item);
    yield call(api.delete, `/borderos/${id}`);
    yield put(BorderosActions.getListBorderos());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchBorderos() {
  try {
    yield put(BorderosActions.getListBorderos());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListBorderosSelects() {
  try {
    const {data: borderos} = yield call(api.get, `/borderos/select`);
    yield put(BorderosActions.getListBorderosSuccessSelects(borderos));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* printBordero({payload}) {
  try {
    const {data: url} = yield call(api.get, `/borderos/${payload.id}/pdf`);
    yield put(BorderosActions.printBorderoSuccess(url.pdf));
    yield put(ModalPrint.openPrintModal());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllBorderos({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/borderos/destroy-many`, {
      borderos_id: payload.selected
    });
    yield put(BorderosActions.getListBorderos());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* getDocsPropostasBordero({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/sales/${payload.id}/docs`);

    if (data.files && data.files.length > 0) {
      data.files = data.files.map(file => {
        file.date = file.date ? moment(file.date).format("DD/MM/YYYY") : "";
        file.created_at = file.created_at ? moment(file.created_at).format("DD/MM/YYYY HH:mm:ss") : "";
        file.user_name = file.user ? file.user.name : "";
        file.size = file.size ? formatSize(file.size) : "";
        return file;
      });
    }
    yield put(BorderosActions.getDocsPropostasBorderoSuccess(data));
      yield put(ModalDocsActions.openDocsModal());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/borderos.js